import React from "react";

import { graphql } from "gatsby";

import {
  Container,
  Content,
  Link,
  Illustration,
  Message,
  Tagline,
  Title,
} from "./GoldenKittyBlock.styles";

export interface GoldenKittyBlockProps extends Queries.SanityGoldenKittyBlock {}

const GoldenKittyBlock: React.FC<GoldenKittyBlockProps> = ({
  tagline,
  title,
}) => (
  <Container>
    <Content>
      <Link href="https://www.producthunt.com/posts/uizard-3/">
        <Illustration
          src="https://ph-static.imgix.net/golden-kitty/2021/intro_kitty.png?auto=format&auto=compress&codec=mozjpeg&cs=strip&w=100&h=100&fit=max&dpr=2/"
          alt="Product Hunt Golden Kitty Award logo"
        />
        <Message>
          <Tagline>{tagline}</Tagline>
          <Title>{title}</Title>
        </Message>
      </Link>
    </Content>
  </Container>
);

export const query = graphql`
  fragment GoldenKittyBlock on SanityGoldenKittyBlock {
    _key
    _type
    tagline
    title
  }
`;

export default GoldenKittyBlock;
